import axiosInstance from "../../../services/axiosInstance";

const instance = axiosInstance();

instance.defaults.baseURL += "/pursuit/contact";

export async function createPursuitContact(variables) {
  const response = await instance.post(`/create`, variables);
  return response.data;
}

export async function updatePursuitContact(variables) {
  const response = await instance.patch("/update", variables);
  return response.data;
}

export async function deletePursuitContact(contact_id) {
  const response = await instance.delete(`/delete/${contact_id}`);
  return response.data;
}
